let availableLanguages = ['en', 'nl', 'fr']
let displayLanguage = 'en'
let langHelper = {
    getDefault() {
        let cookieLang = this.getCookie()
        let defaultLang = cookieLang ? cookieLang : this.getNavigatorLang()
        return this.langAvailable(defaultLang) ? defaultLang : displayLanguage
    },
    getCookie() {
        return localStorage.getItem('lang')
    },
    getNavigatorLang() {
        return require('browser-locale')().substring(0,2)
    },
    setCookie(lang) {
        if (this.langAvailable(lang)) {
            localStorage.setItem('lang', lang)
        }
    },
    langAvailable(lang) {
        return Array.isArray(availableLanguages) && availableLanguages.includes(lang)
    }
}

export {
    langHelper,
    availableLanguages,
    displayLanguage
}
